export default "__VITE_ASSET__5f8da9ab__"